import { StateActions } from '@app/core/store/shared/state';
import { Tag } from '@app/features/tag/shared/tag.type';

export class TagActions extends StateActions<Tag> { }
